module.exports = __webpack_public_path__ + "static/media/slackr.b77cbf4a.png";